import ImgCutter from "vue-img-cutter";
import InitImg from "@/assets/默认logo 360@1x.png";
export default {
  name: "Uploadcutter",
  components: {
    ImgCutter
  },
  props: {
    file: {
      type: null,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      select: false,
      InitImg
    };
  },
  methods: {
    cutDown(fileValue) {
      this.$emit("on-change", fileValue);
    },
    mouseEnter() {
      this.select = true;
    },
    mouseLeave() {
      this.select = false;
    }
  }
};